import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";
import dateConverter from "../../../../utils/converters/date.converter";

export default class IndexationRefinement {
  constructor(paymentParametersId, newRate, needToUpdateDiscountRate, newFirstIndexationDate) {
    this.commandName = "IndexationRefinement";
    this.paymentParametersId = paymentParametersId;
    this.newRate = newRate;
    this.needToUpdateDiscountRate = needToUpdateDiscountRate;
    this.newFirstIndexationDate = newFirstIndexationDate;


    let convertedDate = null;
    if(this.newFirstIndexationDate !== null) {
      convertedDate = dateConverter.convertToDate(this.newFirstIndexationDate);
    }

    let dateDescr = '';
    if(convertedDate) {
      dateDescr = `${i18n.t('CONTENT.events.newFirstIndexationDate')} - ${i18n.d(convertedDate)}`
    }

    this.description =
      `${i18n.t('CONTENT.discountRates.rate')}: ${this.newRate}; ${i18n.t('CONTENT.events.needToUpdateDiscountRate')} - ${this.newFirstIndexationDate === true ? i18n.t('CONTENT.yes') : i18n.t('CONTENT.no')}; ${dateDescr}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewRate: this.newRate,
        NeedToUpdateDiscountRate: this.needToUpdateDiscountRate,
        NewFirstIndexationDate: this.newFirstIndexationDate
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
